import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { T, F } from 'ramda'

import TitleDetail from './title-detail'
import TitleList from './title-list'
import { JSONLD } from '../jsonld/index'
import { createMovieLDSchema } from '../../lib/jsonld/movie'
import ContentDescription from '../shared/content-description'
import { getShowPageMargin } from '../../lib/utils'
import { useAddToMyListQS } from '../../hooks/use-add-to-my-list-qs'
import TITLE_COMPONENT_FRAGMENT from '../../../graphql/fragments/title-component.gql'

function Title({
  component, theme, screenWidth, addToMyList, removeFromMyList, isContentItemOnMyList
}) {
  const { title } = component
  useAddToMyListQS(title)
  // Get the notes from TitleDetail then pass them into ContentDescription
  const [notes, setNotes] = useState([])
  const margin = getShowPageMargin(screenWidth)

  return (
    <>
      <TitleDetail
        contentItem={title}
        screenWidth={screenWidth}
        onNotesLoaded={setNotes}
        margin={margin}
      />

      <ContentDescription contentItem={title} notes={notes} margin={margin} />

      <TitleList
        title={title}
        addToMyList={addToMyList}
        removeFromMyList={removeFromMyList}
        isContentItemOnMyList={isContentItemOnMyList}
        theme={theme}
        margin={margin}
      />

      <JSONLD schema={createMovieLDSchema(title)} type="Movie" />
    </>
  )
}

Title.propTypes = {
  component: propType(TITLE_COMPONENT_FRAGMENT).isRequired,
  theme: PropTypes.string.isRequired,
  screenWidth: PropTypes.number.isRequired,
  addToMyList: PropTypes.func,
  removeFromMyList: PropTypes.func,
  isContentItemOnMyList: PropTypes.func
}

Title.defaultProps = {
  addToMyList: T,
  removeFromMyList: T,
  isContentItemOnMyList: F
}

export default Title
